import React from 'react'
import Twemoji from "twemoji";

import AnnotationHeader from './AnnotationHeader'
import AnnotationCommentBox from './AnnotationCommentBox'
import AnnotationCommentList from './AnnotationCommentList'
import CardSubmitActions from './CardSubmitActions'
import EmojiData from "./emojis.json";

class CommentAnnotation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {comment: '', attachment: null };

    this.setComment = this.setComment.bind(this)
    this.handleCommented = this.handleCommented.bind(this)
    this.handleResolve = this.handleResolve.bind(this)
    this.handleAttachFile = this.handleAttachFile.bind(this)
    this.onFileUpload = this.onFileUpload.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }

  setComment(msg) {
    this.setState({comment: msg});
  }

  handleDelete() {
    this.props.klass.deleteAnnotation(this.props.annotation.id)
  }

  searchEmojis(emoji) {
    let found = false;
    let name = "";
    Object.keys(EmojiData).forEach((key) => {
      if (!found) {
        const match = EmojiData[key].find(e => e.icon === emoji);
        if (match) {
          name = match.name;
          found = true;
        }
      }
    });
    return name;
  }

  handleCommented() {
    const comment = this.convertEmoji(this.state.comment);
    this.props.klass.submitComment(this.props.annotation, comment, $('.js-attachment-upload').attr('src'))
    // TODO make this a promise or something
    this.setState({ comment: "", attachment: null });
  }

  handleResolve() {
    this.props.klass.resolveAnnotation(this.props.annotation)
  }

  componentWillUnmount(){
    $(document).off('change', '.js-attach-file');
  }

  handleAttachFile(e) {
    if ($(e.target).hasClass('disabled')) {
      return false
    }
    $('.js-attach-file').click()
  }

  onFileUpload(event) {
    // smaller than 10mb
    if (event.target.files[0].size > 10000000){
      new N2Styles.toast('File is too large.')
      return false
    } else {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (eve) => {
        $('.js-attach-file').val('')
        this.setState({attachment: eve.target.result})
      }
    }
  }

  // the emoji picker in Froala uses a different format than the AnnotationComment is expecting
  // so any emoji not converted will prevent the comment from saving
  convertEmoji(content) {
    let contentToParse = content;
    Twemoji.replace(content, (emoji) => {
      const unicodeEmoji = this.searchEmojis(emoji);
      if (unicodeEmoji) {
        const regex = new RegExp(emoji, "g");
        contentToParse = contentToParse.replace(regex, `:${unicodeEmoji}:`);
      }
    });
    return contentToParse;
  }

  render() {
    const limit = this.props.limit || 800;

    return (
      <div className="card p-0">
        <AnnotationHeader
          onSelect={this.props.onSelect}
          annotation={this.props.annotation}
          readOnly={this.props.readOnly}
          roleType={this.props.roleType}
          annotationTypes={this.props.annotationTypes} />

        <AnnotationCommentList klass={this.props.klass} messages={this.props.annotation.messages} roleType={this.props.roleType} annotation={this.props.annotation} />

        <AnnotationCommentBox
          attachment={this.state.attachment}
          onChange={this.setComment}
          readOnly={this.props.readOnly}
          comment={this.state.comment}
          klass={this.props.klass} />

        <CardSubmitActions
          klass={this.props.klass}
          onSubmit={this.handleCommented}
          onAttach={this.handleAttachFile}
          onResolve={this.handleResolve}
          readOnly={this.props.readOnly}
          resolved={this.props.annotation.resolved}
          roleType={this.props.roleType}
          onFileUpload={this.onFileUpload} />
      </div>
      )
  }
}

export default CommentAnnotation
